import { init } from './init'
import { list } from './list'
import { quote } from './quote'
import { motor } from './motor'
import { cargo } from './cargo'
import { fire } from './fire'
import { maid } from './maid'
import { travel } from './travel'
import { pkg } from './package'
import { pa } from './pa'
import { post } from './post'
import { updateStatus } from './updateStatus'

export const mutations = Object.assign({}, init, list, quote, motor, cargo, fire, maid, travel, pkg, pa, post, updateStatus)
